export const initialExercise = {
    exercise: null
};

export const initialExerciseGroup = {
    exercises: [initialExercise]
};

